// extracted by mini-css-extract-plugin
export var errorIcon = "_lp-1";
export var nameLogo = "_lp-0";